<template>
    <div >
        <div class="row no-gutters body"> 
            <div class="col-12  main-card" v-if="paymentSuccessful || choosePlanSection">
                <div class="col-12 pb-5 mb-4" v-if="loadingForLandingPricing">
                    <div class="d-flex flex-column">
                        <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
                        <span class="font-size14 proximanova-semibold black80 text-center mt-5">Initiating payment flow. Please wait for a moment...</span>
                    </div>
                </div>
                <div class="row no-gutters" v-else>
                    <div class=" middle-background" :class="{'col-lg-3' :!choosePlanSection}">
                        <div class="row no-gutters">
                            <br />
                        </div>
                        <div class="d-flex ml-3 ml-lg-5 mt-5 p-lg-2 pt-4 pointer" @click="navToProfileViews">
                            <img src="../assets/Back.svg" class="backbtn" alt="back"/>
                            <p class="fontsize20 proximanova-semibold black ml-3 mt-2">Premium Account</p>
                        </div>
                    </div>
                    <!-- plan selection cards -->
                    <div class="col-md-12 col-lg-6 middle-background pb-5" :class="{'col-lg-9' :choosePlanSection}" v-if="choosePlanSection">
                        <div class="row no-gutters d-none d-lg-block">
                            <br />
                        </div>
                        <div class="no-gutters mt-lg-5 ">
                            <div class="col-lg-11 mx-auto"> 
                                <div class="row no-gutters">
                                    <br />
                                </div>
                                <div class="d-flex ml-3 mr-3 pt-lg-3">
                                    <span class="fontsize20 proximanova-semibold black">Choose the plan</span>
                                    <span class="fontsize20 black proximanova ml-1">that's right for you</span>
                                </div>
                                <div class="ml-3 mr-3 d-flex justify-content-between">
                                    <span class="fontsize12 proximanova black60 mt-2">Choose Annual plan to save 30%</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-11 mt-3 mx-auto">
                            <div class="d-flex justify-content-between mr-3">
                                <div class="d-flex">
                                    <span class="fontsm proximanova fontbold mt-2 pt-1 mr-lg-3 mr-1">Billing Country</span>
                                    <!-- <select name="billingCountry" id="billingCountry" disabled class="proximanova borderradius20" v-model="dataSharingObject.billingCountry" @change="setCurrencyType">
                                        <option value="USA">USA</option>
                                        <option value="India">India</option>
                                    </select> -->
                                    <span id="billingCountry1" disabled class="proximanova borderradius20 fontsize14 my-auto">United States of America (USA)</span>
                                </div>
                                <!-- <div>
                                    <img src="../assets/Info.svg" alt="">
                                    <button class="freetrailbtn ml-2" v-if="this.remainingDaysLeft < 1 && this.freeTrailAccess !== 'Y'" @click="FreetrailAccess">Free trail</button>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-lg-11 col-md-12 viewercards row no-gutters mb-4 mt-4" >
                            <div class="col-lg-4 col-md-6 p-2" @click="changecardColour('freeplan')">
                                <div class="card p-3 ml-3 ml-lg-3 planCards mr-3 mr-md-0 mr-lg-0 mb-2 pointer"  :class="{'premium':freeplancardselected}">
                                    <div class="tickmark" v-if="!currentPlanDetails">&#10003;</div>
                                    <div class="mt-2 text-center">
                                        <span class="fontsize24 proximanova black">Free Plan</span>
                                    </div>
                                    <div class="hotizonline p-2 mb-2"></div>
                                    <div class="d-flex flex-column text-center">
                                        <span class="amountcolor proximanova" v-if="dataSharingObject.currencyType === 'USD'">$0</span>
                                        <span class="amountcolor proximanova" v-if="dataSharingObject.currencyType === 'INR'">₹0</span>
                                        <span class="fontsize12 proximanova black60 p-1" >Free forever</span>
                                    </div>
                                    <div class="mb-2 p-3 text-center">
                                        <div class="d-flex flex-column btnsection">
                                            <button type="button" 
                                            class="btn followbtn proximanova-bold fontsize16 black80 mouseoverbtn2 borderradius20" 
                                            :disabled="!freeplancardselected || (currentPlanDetails && currentPlanDetails.status === 'N')" 
                                            v-if="currentPlanDetails !== null"
                                            :class="{'backgroundcolorblack white':freeplancardselected}" 
                                            @click="cancelPlan()">Downgrade</button>
                                            <button type="button" :disabled="!freeplancardselected" 
                                            class="btn followbtn proximanova-bold fontsize16 black80 mouseoverbtn2 borderradius20" 
                                            :class="{'backgroundcolorblack white':freeplancardselected}"
                                            v-if="currentPlanDetails === null">Current Plan</button>
                                        </div>
                                    </div>
                                    <div class="hotizonline p-2 mb-2"></div>
                                    <div class="d-flex flex-column">
                                        <span class="font16black ml-2 mb-2 proximanova">Benefits</span>
                                        <ul class="fontsize12 black benifits proximanova pl-0 ml-2">
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Find who viewed my profile upto 3 profiles</li>
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Upto 3 profiles - Find who viewed my video profile</li>
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Upto 3 profiles - Find who viewed your video's</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 p-2" @click="changecardColour('Monthly')">
                                <div class="card p-3 ml-3 ml-lg-3 planCards mr-3 mr-md-0 mr-lg-0 mb-2 pointer" :class="{'premium':monthlycardselected}" >
                                    <div class="tickmark" v-if="currentPlanDetails && currentPlanDetails.planType === 'Monthly'">&#10003;</div>
                                    <div class="mt-2 text-center">
                                        <span class="fontsize24 proximanova black">Monthly Plan</span>
                                    </div>
                                    <div class="hotizonline p-2 mb-2"></div>
                                    <div class="d-flex flex-column text-center">
                                        <span class="amountcolor proximanova" v-if="dataSharingObject.currencyType === 'USD'">${{monthlyPlanAmount}}</span>
                                        <span class="amountcolor proximanova" v-if="dataSharingObject.currencyType === 'INR'">₹{{monthlyPlanAmount}}</span>
                                        <span class="fontsize12 proximanova black60 p-1" v-if="currentPlanDetails === null && subscriptionsList.length < 2 && !HideFreeBtnBaseonPaymentStatus">30 days free trail</span>
                                        <span class="fontsize14 black pb-1 proximanova" v-if="dataSharingObject.currencyType === 'USD'">After free trail - ${{monthlyPlanAmount}} / Month</span>
                                        <span class="fontsize14 black pb-1 proximanova" v-if="dataSharingObject.currencyType === 'INR'">After free trail - ₹{{monthlyPlanAmount}} / Month</span>
                                    </div>
                                    <div class="mb-2 p-3 text-center">
                                        <div class="d-flex flex-column btnsection">
                                            <button type="button" 
                                            class="btn followbtn proximanova-bold fontsize16 black80 mouseoverbtn2 borderradius20" 
                                            :disabled="!monthlycardselected" 
                                            v-if="currentPlanDetails === null && subscriptionsList.length < 2 && !HideFreeBtnBaseonPaymentStatus"
                                            :class="{'backgroundcolorblack white':monthlycardselected}" 
                                            @click="FreetrailAccess('Monthly')">Start Free trail</button>
                                            <span class="fontsize14 black proximanova" v-if="currentPlanDetails === null && subscriptionsList.length< 2 && !HideFreeBtnBaseonPaymentStatus">(OR)</span>
                                            <button type="button" 
                                            class="btn followbtn proximanova-bold fontsize16 black80 mouseoverbtn2 borderradius20" 
                                            :disabled="!monthlycardselected" 
                                            v-if="currentPlanDetails === null"
                                            :class="{'backgroundcolorblack white':monthlycardselected}" 
                                            @click="subscribesection('Monthly')">Subscribe</button>
                                            <button type="button" 
                                            class="btn followbtn proximanova-bold fontsize16 black80 mouseoverbtn2 borderradius20" 
                                            :disabled="!monthlycardselected" 
                                            :class="{'backgroundcolorblack white':monthlycardselected}"
                                            v-if="currentPlanDetails !== null && currentPlanDetails.planType !== 'Monthly' && currentPlanDetails.status === 'N'"
                                            @click="subscribewhenplancancel('Monthly')">Subscribe</button>
                                            <button type="button" 
                                            class="btn followbtn proximanova-bold fontsize16 black80 mt-3 mb-2 mouseoverbtn2 borderradius20" 
                                            :disabled="!monthlycardselected" 
                                            v-if="currentPlanDetails !== null && currentPlanDetails.planType !== 'Monthly' && currentPlanDetails.status === 'Y'"
                                            :class="{'backgroundcolorblack white':monthlycardselected}" 
                                            @click="PlanUpgradeDowngrade('Monthly')">Downgrade</button>
                                            <!-- <button type="button" 
                                            class="btn followbtn proximanova-bold fontsize16 black80 mt-3 mb-2 mouseoverbtn2 borderradius20" 
                                            :disabled="!monthlycardselected" 
                                            v-if="currentPlanDetails !== null && currentPlanDetails.planType !== 'Monthly'"
                                            :class="{'backgroundcolorblack white':monthlycardselected}" 
                                            data-toggle="modal" data-target="#inprogressmodal">Downgrade</button> -->
                                            <div v-if="currentPlanDetails && currentPlanDetails.planType === 'Monthly'" class="fontbold proximanova">Subscribed Plan</div>
                                            <button class="freetrailbtn ml-2 mt-2 proximanova mouseoverbtn2 borderradius20" 
                                            v-if="currentPlanDetails && currentPlanDetails.planType === 'Monthly' && currentPlanDetails.status === 'Y'" 
                                            data-toggle="modal" data-target="#deleteExpModal">Cancel Plan</button>
                                            <button class="freetrailbtn ml-2 mt-2 proximanova" @click="ReactivatePlan('Monthly')"
                                            v-if="currentPlanDetails && currentPlanDetails.planType === 'Monthly' && currentPlanDetails.status === 'N'" 
                                            >Re-activate plan</button>
                                            <!-- <button class="freetrailbtn ml-2 mt-2 proximanova" data-toggle="modal" data-target="#inprogressmodal"
                                            v-if="currentPlanDetails && currentPlanDetails.planType === 'Monthly' && currentPlanDetails.status === 'N'" 
                                            >Re-activate plan</button> -->
                                            <div class="endateheight">
                                                <span v-if="currentPlanDetails && currentPlanDetails.endD && currentPlanDetails.planType === 'Monthly'" 
                                            class="linearcolors fontsize12 proximanova-bold">Current Plan will expires on {{ currentPlanEndDate | moment("MMM Do YYYY") }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="hotizonline p-2 mb-2"></div>
                                    <div class="d-flex flex-column">
                                        <span class="font16black ml-2 mb-2 proximanova">Benefits</span>
                                        <ul class="fontsize12 black benifits proximanova pl-0 ml-2">
                                            <li v-if="currentPlanDetails === null && subscriptionsList.length < 2 && !HideFreeBtnBaseonPaymentStatus"> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit"> 30 days free trail</li>
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Access to connect premium accounts</li>
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Find who viewed my profile</li>
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Find who viewed my video profile</li>
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Find who viewed your video's</li>
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Connect directly with recruiters</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 p-2" @click="changecardColour('Annually')">
                                <div class="card p-3 ml-3 mr-3 planCards mr-md-0 mb-2 pointer" :class="{'premium':annualcardselected}">
                                    <div class="tickmark" v-if="currentPlanDetails && currentPlanDetails.planType === 'Annually'">&#10003;</div>
                                    <div class="">
                                        <span class="float-right suggestedpillbtn fontsize12 proximanova-bold greendark proximanova">Popular</span>
                                    </div>
                                    <div class="mt-2 text-center">
                                        <span class="fontsize24 proximanova black">Annual Plan</span>
                                    </div>
                                    <div class="hotizonline p-2 mb-2"></div>
                                    <div class="d-flex flex-column text-center">
                                        <span class="strikeamountcolor proximanova" v-if="dataSharingObject.currencyType === 'USD'"><del>$120</del></span>
                                        <span class="amountcolor proximanova" v-if="dataSharingObject.currencyType === 'USD'">${{annualPlanAmount}}</span>
                                        <span class="amountcolor proximanova" v-if="dataSharingObject.currencyType === 'INR'">₹{{annualPlanAmount}}</span>
                                        <span class="fontsize12 proximanova black60 p-1" v-if="currentPlanDetails === null && subscriptionsList.length < 2 && !HideFreeBtnBaseonPaymentStatus">30 days free trail</span>
                                        <span class="fontsize14 black pb-1 proximanova" v-if="dataSharingObject.currencyType === 'USD'">After free trail - ${{annualPlanAmount}} / Annual</span>
                                        <span class="fontsize14 black pb-1 proximanova" v-if="dataSharingObject.currencyType === 'INR'">After free trail - ₹{{annualPlanAmount}} / Annual</span>
                                    </div>
                                    <div class="mb-2 p-3 text-center">
                                        <div class="d-flex flex-column btnsection">
                                            <button type="button" 
                                            class="btn followbtn proximanova-bold fontsize16 black80 mouseoverbtn2 borderradius20" 
                                            :disabled="!annualcardselected" 
                                            :class="{'backgroundcolorblack white':annualcardselected}" 
                                            v-if="currentPlanDetails === null && subscriptionsList.length < 2 && !HideFreeBtnBaseonPaymentStatus"
                                            @click="FreetrailAccess('Annually')">Start Free trail</button>
                                            <span class="fontsize14 black proximanova" v-if="currentPlanDetails === null && subscriptionsList.length < 2 && !HideFreeBtnBaseonPaymentStatus">(OR)</span>
                                            <button type="button" 
                                            class="btn followbtn proximanova-bold fontsize16 black80 mouseoverbtn2 borderradius20" 
                                            :disabled="!annualcardselected" 
                                            :class="{'backgroundcolorblack white':annualcardselected}"
                                            v-if="currentPlanDetails === null"
                                            @click="subscribesection('Annually')">Subscribe</button>
                                            <button type="button" 
                                            class="btn followbtn proximanova-bold fontsize16 black80 mouseoverbtn2 borderradius20" 
                                            :disabled="!annualcardselected" 
                                            :class="{'backgroundcolorblack white':annualcardselected}"
                                            v-if="currentPlanDetails !== null && currentPlanDetails.planType !== 'Annually' && currentPlanDetails.status === 'N'"
                                            @click="subscribewhenplancancel('Annually')">Subscribe</button>
                                            <button type="button" 
                                            class="btn followbtn proximanova-bold fontsize16 black80 mt-3 mb-2 mouseoverbtn2 borderradius20" 
                                            :disabled="!annualcardselected" 
                                            :class="{'backgroundcolorblack white':annualcardselected}"
                                            v-if="currentPlanDetails !== null && currentPlanDetails.planType !== 'Annually' && currentPlanDetails.status === 'Y'"
                                            @click="PlanUpgradeDowngrade('Annually')">Upgrade</button>
                                            <!-- <button type="button" 
                                            class="btn followbtn proximanova-bold fontsize16 black80 mt-3 mb-2 mouseoverbtn2 borderradius20" 
                                            :disabled="!annualcardselected" 
                                            :class="{'backgroundcolorblack white':annualcardselected}"
                                            v-if="currentPlanDetails !== null && currentPlanDetails.planType !== 'Annually'"
                                            data-toggle="modal" data-target="#inprogressmodal">Upgrade</button> -->
                                            <div v-if="currentPlanDetails && currentPlanDetails.planType === 'Annually'" class="fontbold proximanova">Subscribed Plan</div>
                                            <button class="freetrailbtn ml-2 mt-2 proximanova mouseoverbtn2 borderradius20" 
                                            v-if="currentPlanDetails && currentPlanDetails.planType === 'Annually' && currentPlanDetails.status === 'Y'" 
                                            data-toggle="modal" data-target="#deleteExpModal" >Cancel Plan</button>
                                            <button class="freetrailbtn ml-2 mt-2 proximanova" @click="ReactivatePlan('Annually')"
                                            v-if="currentPlanDetails && currentPlanDetails.planType === 'Annually' && currentPlanDetails.status === 'N'" 
                                            >Re-activate plan</button>
                                            <!-- <button class="freetrailbtn ml-2 mt-2 proximanova" data-toggle="modal" data-target="#inprogressmodal"
                                            v-if="currentPlanDetails && currentPlanDetails.planType === 'Annually' && currentPlanDetails.status === 'N'" 
                                            >Re-activate plan</button> -->
                                            <div class="endateheight">
                                            <span v-if="currentPlanDetails && currentPlanDetails.endD && currentPlanDetails.planType === 'Annually'" 
                                            class="linearcolors fontsize12 proximanova-bold">Current Plan will expires on {{ currentPlanEndDate | moment("MMM Do YYYY") }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="hotizonline p-2 mb-2"></div>
                                    <div class="d-flex flex-column">
                                        <span class="font16black ml-2 mb-2 proximanova">Benefits</span>
                                        <ul class="fontsize12 black benifits proximanova pl-0 ml-2">
                                            <li v-if="currentPlanDetails === null && subscriptionsList.length < 2 && !HideFreeBtnBaseonPaymentStatus"> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit"> 30 days free trail</li>
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Access to connect premium accounts</li>
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Find who viewed my profile</li>
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Find who viewed my video profile</li>
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Find who viewed your video's</li>
                                            <li> <img src="../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Connect directly with recruiters</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- alert modal to cancel the plan -->
                        <div class="modal fade" id="deleteExpModal" tabindex="-1" role="dialog" aria-labelledby="deleteExpModalLabel" aria-hidden="true">
                            <div class="modal-dialog " role="document">
                                <div class="modal-content">
                                    <div class="modal-header delete-modal">
                                        <h5 class="modal-title fontsize20 black80 proximanova" id="deleteExpModalLabel">Are you sure you want to cancel the plan ?</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body modal-delete text-center pt-0">
                                        <span class="button-cancel-font modaldeletebtn border proximanova modalbtn pointer borderradius20 p-2 pr-4 pl-4" data-dismiss="modal" aria-label="Close">No</span>
                                        <span class="button-cancel-font backgroundcolorblack white border proximanova pointer p-2 ml-2 pr-4 pl-4 borderradius20" @click="cancelSubscription">Yes</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- inprogress modal -->
                        <div class="modal backgroundnone fade confirmmodal" :id="'inprogressmodal'" tabindex="-1" role="dialog" aria-labelledby="deleteLikeVideoModalLabel" aria-hidden="true">
                            <div class="modal-dialog " role="document">
                                <div class="modal-content pb-2">
                                    <div class="modal-header delete-modal pb-0">
                                    <h5 class="modal-title fontsize20 black80 proximanova" id="deleteLikeVideoModalLabel">This functionality is in progress...</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    </div>
                                    <div class="modal-body backgroundcolorwhite modal-delete text-center">
                                        <span class="button-cancel-font modaldeletebtn pointer border borderradius20 p-2 pr-4 pl-4 proximanova" data-dismiss="modal" aria-label="Close" >close</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- payment successfull card -->
                    <div class="col-md-12 col-lg-6 pb-5 middle-background" v-if="paymentSuccessful">
                        <div class="row no-gutters mt-lg-5">
                            <br />
                        </div>
                        <div class="col-lg-11 col-md-12 viewercards row no-gutters mt-1" >
                            <div class="col-12 mt-lg-2" >
                                <div class="card ml-3 mr-3 mt-3" >
                                    <div class="d-flex p-2 ml-lg-3">
                                        <div class="p-2">
                                            <img src="../assets/PaymentSucessfull.svg" alt="successful">
                                        </div>
                                        <div class="p-2 ml-2 d-flex flex-column">
                                            <span class="black80 fontsize24 proximanova mt-0">Payment Successful</span>
                                            <span class="font12Italic proximanova" v-if="scheduleMessage === null">Payment will consider after 30 days of your free trail</span>
                                            <span class="font12Italic proximanova" v-if="scheduleMessage">{{scheduleMessage}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col middle-background d-none d-lg-block">
                        <div class="row no-gutters">
                            <br />
                        </div>
                        <div class="row no-gutters">
                            <br />
                        </div>
                        <div class="d-flex mt-5 mr-5 pt-2 float-right closebtnprem" @click="navToProfileViews">
                            <span class="page-font-size mr-1 proximanova">Close</span>
                            <img src="../assets/closecrossbtn.svg" class="img-fluid" alt="close">
                        </div>
                    </div>
                </div>
            </div> 
            <!-- payment section (easypay iframe) -->
            <div class="col-12 mt-lg-5" id="parentDiv" v-if="paymentsection">
                <div class="pt-2">
                    <div class="d-flex ml-3 ml-md-5 p-lg-2 pt-5 pointer" @click="navToProfileViews">
                        <img src="../assets/Back.svg" class="backbtn mt-1" alt="back"/>
                        <p class="fontsize20 proximanova-semibold black ml-3 mt-4">Premium Account</p>
                    </div>
                </div>
                <!-- <input type="text" id="parentInput" value="check" @change="ChangeInputValue"> -->
                <!-- <payment-schedule :dataSharingObject="dataSharingObject"></payment-schedule> -->
                <iframe :src="easypayURL" id="easypaywindow"
                style="position:relative;z-index:0"
                name="myIframe"
                v-on:load="onLoadIframe" frameborder="0"></iframe>
            </div>
        </div>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal> 
    </div>
</template>
<script>
import httpuserprofile from "../js/http-userprofile.js"
import DatePicker from 'vue2-datepicker';
import router from '../router.js'
import httppayment from "@/js/http-payment.js";
import PaymentSchedule from './PaymentSchedule.vue'
import moment from 'moment'
import cryptoscript from '@/js/cryptoscript.js'
import htttpsignup from "@/js/http-userdetails.js";
import { bus } from "../main";
import wndata from '../js/wn_data.json'
import APIerrorModal from '../components/APIerrorpopup.vue'
import sessionUtils from '@/js/session-util.js'
import $ from 'jquery'
export default {
    components: {
        DatePicker,
        APIerrorModal,
        PaymentSchedule
    },
    watch: {

    },
    data(){
        return {
            activeClass : 'people',
            // currentUser : null,
            currentUserId : null,
            currentUserProfileId : null,
            freeplancardselected : true,
            monthlycardselected : false,
            annualcardselected : false,
            choosePlanSection : true,
            clickonFreeTrail : false,
            paymentsection : false,
            // remainingDaysLeft : null,
            // freeTrailAccess : null,
            easypayURL : '',
            currentUserDetails : null,
            selectedPlanAmount : null,
            dataSharingObject : {
                billingCountry : 'USA',
                currencyType : 'USD',
                payableAmount : 10,
                // originalPrice : '8',
                // SeriviceTax : '2',
                paymentFrequency : 'Monthly',
                // clientEmail : 'muthu.p@syntrino.net',
                // clientId : 'WN_51J4ut0DTZ'
                clientEmail : '',
                clientId : '',
                reactive_upgreade_downgrade : null
            },
            customerDetails : {
                customerId : 0,
                email : null,
                firstName : null,
                lastName : null,
                phoneNumber : null
            },
            subscriptionId : null,
            selectedPlanForEntitlements : null,
            customerId : 0,
            //if billing country is USA
            rupeesperdollar : null,
            indianTax : null,
            usTax : null,
            monthlyPlanAmount : null,
            annualPlanAmount : null,
            monthlyAmountForServices : null,
            annualAmountForServices : null,
            storedPaymentId : null,
            paymentToken : null,
            paymentSuccessful : false,
            currentPlanDetails : null,
            currentPlanEndDate : null,
            subscriptionsList : [],
            HideFreeBtnBaseonPaymentStatus : false,
            subscriptionObj : {
                id : null,
                profileId : this.currentUserProfileId,
                epcustomerId : 0,
                startD : null,
                endD : null,
                planType : null,
                paymentStatus : null,
                subscriptionD : null,
                transactionD : null,
                amount : null,
                status : 'N',
                transactionId : null,
                currencyType : 'USD',
                tax : null
            },
            subscribeAfterPlanCancel : false,
            //timezone
            zone : 'America/New_York',
            scheduleMessage : null,
            //direct plan selection from landing page
            loadingForLandingPricing : false,
            selectedPlanCard : false,
            selectedPlanType : null,
            displayAPIerrorModal : false,
        }
    },
    
    methods: {
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        //this will invoke on loading an iframe to pass the data from parent to child
        onLoadIframe() {
            console.log("check")
            // document.getElementById('parentInput').value = 'Jagadeesh';
            var receiverWindow = document.getElementById("easypaywindow").contentWindow;
            this.dataSharingObject.clickonFreeTrail = this.clickonFreeTrail;
            this.dataSharingObject.customerDetails = this.customerDetails;
            this.dataSharingObject.subscriptionId = this.subscriptionId;
            receiverWindow.postMessage(this.dataSharingObject, this.easypayURL);
        },
        cancelPlan() {
            $('#deleteExpModal').modal('show')
        },
        //cancel subscription
        cancelSubscription : function(){
            console.log()
            this.selectedPlanForEntitlements = 'Free'
            var vm = this;
            // httppayment.post('/payment/cancelSchedulePayment?customerId='+this.customerId+'&clientId=WN_51J4ut0DTZ&loggedInUser='+this.currentUserDetails.fullName)
            httppayment.post('/payment/cancelSchedulePayment?customerId='+this.customerId+'&clientId='+this.dataSharingObject.clientId+'&loggedInUser='+this.currentUserDetails.fullName)
            .then((response) => {
                console.log(response)
                // vm.$toast.success("Successfully cancelled Next scheduled payment")
                vm.$toast.success(response.data.apiResponseMessage)
                this.subscriptionObj.status = 'N';
                this.currentPlanDetails.status = 'N'
                $('#deleteExpModal').modal('hide')
                this.updateSubscriptionPlan('NotupdateEntitlement')
                // this.currentPlanDetails = null;
                // this.getLastUpdatedPlanDetails()
                // this.setSubscriptionObject()
            }).catch((e) => {
                console.log(e.response)
                this.displayAPIerrorModal = true;
            })
        },
        //reactivate the plan
        ReactivatePlan : function(type) {
            this.dataSharingObject.reactive_upgreade_downgrade = 'reactivate';
            console.log("reactivating the plan : ", type)
            //display iframe to check wether we have to use same card or new card
            this.loadingForLandingPricing = false;
            this.paymentsection = true;
            this.choosePlanSection = false;
            this.paymentSuccessful = false;
            // this.subscriptionObj.status = 'Y';
            // this.updateSubscriptionPlan('NotupdateEntitlement')
            // this.schedulePaymentAfterReactivate()
        },
        PlanUpgradeDowngrade : function(type) {
            var vm = this;
            if(this.currentPlanDetails && this.currentPlanDetails.status === 'Y'){
                this.dataSharingObject.reactive_upgreade_downgrade = 'upgradedowngrade';
                console.log("reactivating the plan : ", type)
                //display iframe to check wether we have to use same card or new card
                this.loadingForLandingPricing = false;
                this.paymentsection = true;
                this.choosePlanSection = false;
                this.paymentSuccessful = false;
            }else{
                vm.$toast.info("You can't upgrade/downgrade your plan when you don't have any active plan")
            }
        },
        //this will invoke after successfully cancel the payment to set the subscription object for next subscription
        setSubscriptionObject(){
            this.subscriptionObj.id = null,
            this.subscriptionObj.epcustomerId = this.customerId,
            this.subscriptionObj.startD = null,
            this.subscriptionObj.endD = null,
            this.subscriptionObj.planType = null,
            this.subscriptionObj.paymentStatus = null,
            this.subscriptionObj.subscriptionD = null,
            this.subscriptionObj.transactionD = null,
            this.subscriptionObj.amount = null,
            this.subscriptionObj.status = 'N',
            this.subscriptionObj.transactionId = null
            console.log("after cancel : ", this.subscriptionObj)
        },
        // this will invoke after secting any card from plan section
        //set the payble amount and other info for further use
        changecardColour : function(type) {
            this.subscribeAfterPlanCancel = false;
            //Amount for schedule payment based on selected card
            if(type === 'Monthly'){
                this.monthlycardselected = true;
                this.annualcardselected = false;
                this.freeplancardselected = false;
                if(this.dataSharingObject.currencyType === 'USD'){
                    this.selectedPlanAmount = this.monthlyAmountForServices;
                }else{
                    this.selectedPlanAmount = this.monthlyAmountForServices * this.rupeesperdollar;
                }
                this.dataSharingObject.paymentFrequency = 'Monthly'
            }else if(type === 'Annually'){
                this.monthlycardselected = false;
                this.annualcardselected = true;
                this.freeplancardselected = false;
                if(this.dataSharingObject.currencyType === 'USD'){
                    this.selectedPlanAmount = this.annualAmountForServices;
                }else{
                    this.selectedPlanAmount = this.annualAmountForServices * this.rupeesperdollar;
                }
                this.dataSharingObject.paymentFrequency = 'Annually'
            }else if(type === 'freeplan'){
                this.freeplancardselected = true;
                this.monthlycardselected = false;
                this.annualcardselected = false;
            }
            console.log(this.subscriptionObj)
        },
        //this will invoke after click on subscribe/free trail button
        setSubscriptionDates(type){
            //date for subscription 
            //////////// set dates when click on subscribe when plan cancelled but active ////
            var time_difference;
            var days_difference;
            if(this.subscribeAfterPlanCancel){
                console.log("currentplandetails : ", this.currentPlanDetails)
                console.log(new Date(this.currentPlanDetails.startD))
                console.log(new Date(this.currentPlanDetails.endD))
                time_difference = new Date(this.currentPlanDetails.endD).getTime() - new Date().getTime();
                days_difference = time_difference / (1000 * 60 * 60 * 24);  
                days_difference = Math.round(days_difference)
                console.log("remaing days : ", days_difference) 
            }
            //////////////////////end////////////////////////
            var momenttimezone = require('moment-timezone');
            var date = new Date()
            let startDate = momenttimezone.tz(date, this.zone).format()
            this.subscriptionObj.startD = startDate;
            this.subscriptionObj.subscriptionD = startDate;
            this.subscriptionObj.transactionD = startDate;
            if(type === 'Monthly'){
                //end date for suscription object
                let endDate = momenttimezone.tz(date.setMonth(date.getMonth() + 1), this.zone).format()
                this.subscriptionObj.endD = endDate
            }else if(type === 'Annually'){
                //end date fro subscription object
                let endDate = momenttimezone.tz(date.setFullYear(date.getFullYear() + 1), this.zone).format()
                this.subscriptionObj.endD = endDate
            }
            //////////// set dates when click on subscribe when plan cancelled but active ////
            if(this.subscribeAfterPlanCancel){
                console.log("enddate of subscription obj : ", this.subscriptionObj.endD)
                let finalDate = new Date(this.subscriptionObj.endD);
                finalDate.setDate(finalDate.getDate() + days_difference);
                finalDate = momenttimezone.tz(finalDate, this.zone).format()
                console.log("final date after adding remaing days : ", finalDate)
                this.subscriptionObj.endD = finalDate
            }
            console.log("currentobj : ", this.currentPlanDetails)
            console.log("subsobj : ", this.subscriptionObj)
            /////////////////////end/////////////////////////
        },
        // invoke after click on subscribe button when plan is cancelled but active
        subscribewhenplancancel(type){
            console.log("into subscribe after cancel")
            this.dataSharingObject.reactive_upgreade_downgrade = null
            this.subscribeAfterPlanCancel = true;
            this.subscriptionObj.id = null;
            this.subscriptionObj.paymentStatus = null;
            this.subscriptionObj.transactionId = null;
            this.subscriptionObj.status = 'N'
            this.subscribesection(type)
        },
        //this will invoke after click on subscribe button in select plan section
        subscribesection : function(type) {
            this.selectedPlanForEntitlements = 'Premium'
            this.setPlanAmount(type)
            this.clickonFreeTrail = false;
            //set plan type for subscription obj
            //////////// set plantye when click on subscribe when plan cancelled but active ////
            this.subscriptionObj.planType = type;
            ///////////////////end///////////////////
            // console.log(this.subscriptionObj)
            // this.registerCustomer()
            this.setSubscriptionDates(type)
            if(this.subscriptionObj.id === null){
                this.addSubscriptionPlan()
            }else{
                this.subscriptionId = this.subscriptionObj.id;
                this.loadingForLandingPricing = false;
                this.paymentsection = true;
                this.choosePlanSection = false;
                this.paymentSuccessful = false;
            }
            console.log("customer details : ", this.customerDetails)
            console.log(this.selectedPlanAmount)
        },
        //this will invoke aftre click on subscribe btn/ free trail btn to get subscription id
        addSubscriptionPlan(){
            console.log(this.subscriptionObj)
            httpuserprofile.post('/userprofile/SubscriptionUsers', this.subscriptionObj)
            .then((response) => {
                console.log("add subscription plan : ", response.data)
                this.subscriptionId = response.data.id;
                if(this.subscriptionId !== null) {
                    this.loadingForLandingPricing = false;
                    this.paymentsection = true;
                    this.choosePlanSection = false;
                    this.paymentSuccessful = false;
                }
                this.subscriptionObj.id = response.data.id
            }).catch((e) => {
                console.log(e.response)
                this.displayAPIerrorModal = true;
            })
        },
        //this will invoke after get the response from easy-pay to update the subscription plan
        updateSubscriptionPlan(updateentitlementstatus){
            httpuserprofile.post('/userprofile/SubscriptionUsers', this.subscriptionObj)
            .then((response) => {
                console.log("update subscription plan : ", response.data)
                this.subscriptionId = response.data.id;
                this.subscriptionObj.id = response.data.id;
                if(response.data.status === 'Y'){
                    bus.$emit('updateActivePlanName', response.data.planType)
                }else{
                    bus.$emit('updateActivePlanName', 'NoPlan')
                }
                if(updateentitlementstatus == 'updateEntitlement'){
                this.updateUserEntitlements()
                }
            }).catch((e) => {
                console.log(e.response)
                this.displayAPIerrorModal = true;
            })
        },
        updateUserEntitlements(){
            httpuserprofile.post('userprofile/updateUserAssignment?profileId='+this.currentUserProfileId+'&roleName='+this.selectedPlanForEntitlements+'&epCustomerId='+this.customerId)
            .then((response) => {
                console.log("update entitlements : ", response)
                this.getUserEntitlements()
            }).catch((e) => {
                console.log(e.response)
                this.displayAPIerrorModal = true;
            })
        },
        //this will invoke after click on subscribe/upgrade button
        setPlanAmount(type){
            if(type === 'Monthly'){
                if(this.dataSharingObject.currencyType === 'USD'){
                    this.dataSharingObject.payableAmount = this.monthlyAmountForServices;
                    this.subscriptionObj.amount = this.monthlyAmountForServices;
                }else{
                    this.dataSharingObject.payableAmount = this.monthlyAmountForServices * this.rupeesperdollar;
                    this.subscriptionObj.amount = this.monthlyAmountForServices * this.rupeesperdollar;
                }
                this.dataSharingObject.paymentFrequency = 'Monthly'
            }else{
                if(this.dataSharingObject.currencyType === 'USD'){
                    this.dataSharingObject.payableAmount = this.annualAmountForServices;
                    this.subscriptionObj.amount = this.annualAmountForServices;
                }else{
                    this.dataSharingObject.payableAmount = this.annualAmountForServices * this.rupeesperdollar;
                    this.subscriptionObj.amount = this.annualAmountForServices * this.rupeesperdollar;
                }
                this.dataSharingObject.paymentFrequency = 'Annually'
            }
            console.log("data sharing object : ", this.dataSharingObject);
            console.log("subscription object : ", this.subscriptionObj)
        },
        // this will invoke after click on change plan section
        movetochangePlanSection : function() {
            this.paymentsection = false;
            this.clickonFreeTrail = false;
            this.choosePlanSection = true;
            this.paymentSuccessful = false;
        },
        // this will invoke after click on back button 
        navToProfileViews : function(){
            // remove following info from localstorage if user accessing screen from pricing screen flow
            localStorage.removeItem("selectedPlan")
            localStorage.removeItem("selectedPlanCard")
            localStorage.removeItem("billingCountry")
            ////////
            if(this.clickonFreeTrail || this.paymentsection) {
                if(this.selectedPlanCard == 'true'){
                    router.go(-1)
                }
                this.clickonFreeTrail = false;
                this.paymentsection = false;
                this.choosePlanSection = true;
                this.paymentSuccessful = false;
                // this.getCurrentPlanDetails()
                this.getLastUpdatedPlanDetails()
            }else if(this.paymentSuccessful){
                if(this.selectedPlanCard == 'true'){
                    router.go(-1)
                }
                this.clickonFreeTrail = false;
                this.paymentsection = false;
                this.choosePlanSection = true;
                this.paymentSuccessful = false;
                // this.getCurrentPlanDetails()
                this.getLastUpdatedPlanDetails()
            }else{
                // router.push({
                //     name : 'profileViews'
                // })
                router.go(-1)
            }
        },
        //this will invoke after click on free trail button on monthly/annual plan cards
        FreetrailAccess :function(type) {
            this.selectedPlanForEntitlements = 'Trial'
            console.log("free trail access")
            this.clickonFreeTrail = true;
            // this.paymentSuccessful = false;
            // this.choosePlanSection = false;
            // this.paymentsection = true;
            //set freetrail data
            //set data for subscription
            this.subscriptionObj.planType = "Free Trail";
            this.subscriptionObj.amount = 0;
            //set data for easypay
            this.dataSharingObject.payableAmount = 0;
            this.dataSharingObject.selectedPlanAmount = this.selectedPlanAmount;
            //this.registerCustomer()
            this.setSubscriptionDates(type)
            if(this.subscriptionObj.id === null){
                this.addSubscriptionPlan()
            }else{
                this.subscriptionId = this.subscriptionObj.id;
                this.paymentsection = true;
                this.choosePlanSection = false;
                this.paymentSuccessful = false;
            }
            console.log(this.subscriptionObj)
            // this.dataSharingObject.SeriviceTax = 0;
            // this.dataSharingObject.originalPrice = 0
        },
        //this will invoke after clicked on reactivate plan
        schedulePaymentAfterReactivate() {
            //payment schedule date calculation
            var vm = this;
            var momenttimezone = require('moment-timezone');
            const d = this.currentPlanDetails.endD;
            let scheduleDate = momenttimezone.tz(d, this.zone).format("YYYY-MMM-DD")
            // let scheduleDate  = moment(d).format("YYYY-MMM-DD");
            let amountPayable;
            if(this.dataSharingObject.currencyType === 'USD'){
                amountPayable = this.selectedPlanAmount * 100
            }else{
                amountPayable = this.selectedPlanAmount
            }
            let paymentObj = {
                amount : amountPayable,
                storedPaymentId : this.storedPaymentId,
                subscriptionId : this.subscriptionObj.id,
                cardDetails : {
                    billingAddress : {
                        addressLine1 : '',
                        addressLine2 : '',
                        addressType : '',
                        city : '',
                        country : this.dataSharingObject.billingCountry,
                        postalCode : '',
                        state : '',
                    },
                    cardNumber : '',
                    expiryMonth : '',
                    expiryYear : '',
                    nameOnCard : '',
                    securityCode : ''
                },
                clientEmail : this.dataSharingObject.clientEmail,
                clientId : this.dataSharingObject.clientId,
                clientName : '',
                currency : this.dataSharingObject.currencyType,
                paymentToken : this.paymentToken,
                customerDetails : this.customerDetails,
                loggedInUser : this.currentUserDetails.fullName,
                paymentFrequency : this.dataSharingObject.paymentFrequency,
                scheduledPaymentDate : scheduleDate
            }
            console.log(paymentObj)
            httppayment.post('/payment/schedulepayment',paymentObj)
            .then((response) => {
                console.log("success : ", response)
                // vm.$toast.success("Next payment scheduled at " + response.data.paymentDate)
                // this.scheduleMessage = "Next payment scheduled at " + response.data.paymentDate
                vm.$toast.success("Next payment scheduled at " + response.data.paymentDate)
                vm.updateSubscriptionPlan('NotupdateEntitlement')
            }).catch((e) => {
                console.log("error : ", e.response)
                this.displayAPIerrorModal = true;
            })
        },
        UpgradeDowngradeSubscription() {
            var vm = this;
            var momenttimezone = require('moment-timezone');
            const d = this.currentPlanDetails.endD;
            let scheduleDate = momenttimezone.tz(d, this.zone).format("YYYY-MMM-DD")
            let amountPayable;
            if(this.dataSharingObject.currencyType === 'USD'){
                amountPayable = this.selectedPlanAmount * 100
            }else{
                amountPayable = this.selectedPlanAmount
            }
            let updateShcedulePaymentObj = {
                amount : amountPayable,
                storedPaymentId : this.storedPaymentId,
                subscriptionId : this.subscriptionId,
                cardDetails : {
                    billingAddress : {
                        addressLine1 : '',
                        addressLine2 : '',
                        addressType : '',
                        city : '',
                        country : this.dataSharingObject.billingCountry,
                        postalCode : '',
                        state : '',
                    },
                    cardNumber : '',
                    expiryMonth : '',
                    expiryYear : '',
                    nameOnCard : '',
                    securityCode : ''
                },
                clientEmail : this.dataSharingObject.clientEmail,
                clientId : this.dataSharingObject.clientId,
                clientName : '',
                currency : this.dataSharingObject.currencyType,
                paymentToken : this.paymentToken,
                customerDetails : this.customerDetails,
                loggedInUser : this.currentUserDetails.fullName,
                paymentFrequency : this.dataSharingObject.paymentFrequency,
                scheduledPaymentDate : scheduleDate
            }
            console.log("modify scedule payment after dongrade/ugrade : ", updateShcedulePaymentObj)
            httppayment.post('/payment/modifySchedulePayment',updateShcedulePaymentObj)
            .then((response) => {
                console.log("modify schedule success : ", response)
                // this.scheduleMessage = "Next payment scheduled at " + response.data.paymentDate
                vm.$toast.success("Next payment scheduled at " + response.data.paymentDate)
            }).catch((e) => {
                console.log("modify schedule error : ", e.response)
                this.displayAPIerrorModal = true;
            })

        },
        //this will invoke after successfully completed the charge payment
        schedulePayment() {
            //payment schedule date calculation
            var vm = this;
            var momenttimezone = require('moment-timezone');
            // const d = new Date(this.subscriptionObj.endD);
            if(this.subscriptionObj.planType === 'Free Trail') {
                d.setMonth(d.getMonth() + 1)
                console.log(d)
            }else{
                // if(this.dataSharingObject.paymentFrequency === 'Monthly'){
                //     d.setMonth(d.getMonth() + 1)
                //     console.log(d)
                // }
                // if(this.dataSharingObject.paymentFrequency === 'Annually'){
                //     d.setFullYear(d.getFullYear() + 1)
                //     console.log(d)
                // }
                const d = new Date(this.subscriptionObj.endD);
            }
            let scheduleDate = momenttimezone.tz(d, this.zone).format("YYYY-MMM-DD")
            // let scheduleDate  = moment(d).format("YYYY-MMM-DD");
            let amountPayable;
            if(this.dataSharingObject.currencyType === 'USD'){
                amountPayable = this.selectedPlanAmount * 100
            }else{
                amountPayable = this.selectedPlanAmount
            }
            let paymentObj = {
                amount : amountPayable,
                storedPaymentId : this.storedPaymentId,
                subscriptionId : this.subscriptionId,
                cardDetails : {
                    billingAddress : {
                        addressLine1 : '',
                        addressLine2 : '',
                        addressType : '',
                        city : '',
                        country : this.dataSharingObject.billingCountry,
                        postalCode : '',
                        state : '',
                    },
                    cardNumber : '',
                    expiryMonth : '',
                    expiryYear : '',
                    nameOnCard : '',
                    securityCode : ''
                },
                clientEmail : this.dataSharingObject.clientEmail,
                clientId : this.dataSharingObject.clientId,
                clientName : '',
                currency : this.dataSharingObject.currencyType,
                paymentToken : this.paymentToken,
                customerDetails : this.customerDetails,
                loggedInUser : this.currentUserDetails.fullName,
                paymentFrequency : this.dataSharingObject.paymentFrequency,
                scheduledPaymentDate : scheduleDate
            }
            console.log(paymentObj)
            httppayment.post('/payment/schedulepayment',paymentObj)
            .then((response) => {
                console.log("success : ", response)
                // vm.$toast.success("Next payment scheduled at " + response.data.paymentDate)
                this.scheduleMessage = "Next payment scheduled at " + response.data.paymentDate
            }).catch((e) => {
                console.log("error : ", e.response)
                this.displayAPIerrorModal = true;
            })
        },
        //this will invoke when user upgrade/downgrade their current plan
        modifySchedulePayment() {
            //payment schedule date calculation
            var vm = this;
            var momenttimezone = require('moment-timezone');
            const d = new Date();
            if(this.subscriptionObj.planType === 'Free Trail') {
                d.setMonth(d.getMonth() + 1)
                console.log(d)
            }else{
                if(this.dataSharingObject.paymentFrequency === 'Monthly'){
                    d.setMonth(d.getMonth() + 1)
                    console.log(d)
                }
                if(this.dataSharingObject.paymentFrequency === 'Annually'){
                    d.setFullYear(d.getFullYear() + 1)
                    console.log(d)
                }
            }
            let scheduleDate = momenttimezone.tz(d, this.zone).format("YYYY-MMM-DD")
            let amountPayable;
            if(this.dataSharingObject.currencyType === 'USD'){
                amountPayable = this.selectedPlanAmount * 100
            }else{
                amountPayable = this.selectedPlanAmount
            }
            let updateShcedulePaymentObj = {
                amount : amountPayable,
                storedPaymentId : this.storedPaymentId,
                subscriptionId : this.subscriptionId,
                cardDetails : {
                    billingAddress : {
                        addressLine1 : '',
                        addressLine2 : '',
                        addressType : '',
                        city : '',
                        country : this.dataSharingObject.billingCountry,
                        postalCode : '',
                        state : '',
                    },
                    cardNumber : '',
                    expiryMonth : '',
                    expiryYear : '',
                    nameOnCard : '',
                    securityCode : ''
                },
                clientEmail : this.dataSharingObject.clientEmail,
                clientId : this.dataSharingObject.clientId,
                clientName : '',
                currency : this.dataSharingObject.currencyType,
                paymentToken : this.paymentToken,
                customerDetails : this.customerDetails,
                loggedInUser : this.currentUserDetails.fullName,
                paymentFrequency : this.dataSharingObject.paymentFrequency,
                scheduledPaymentDate : scheduleDate
            }
            console.log(updateShcedulePaymentObj)
            httppayment.post('/payment/modifySchedulePayment',updateShcedulePaymentObj)
            .then((response) => {
                console.log("modify schedule success : ", response)
                // vm.$toast.success("Next payment scheduled at " + response.data.paymentDate)
                this.scheduleMessage = "Next payment scheduled at " + response.data.paymentDate
            }).catch((e) => {
                console.log("modify schedule error : ", e.response)
                this.displayAPIerrorModal = true;
            })
        },
        //this will invoke after loading the component
        getUserData() {
            httpuserprofile.get('/userprofile/userbyid/'+sessionUtils.getUserId())
            .then(response =>{
                console.log(response)
                this.currentUserDetails = response.data
                this.currentUserDetails.fullName = this.currentUserDetails.firstName + ' ' + this.currentUserDetails.lastName;
                // this.dataSharingObject.customerDetails ={
                //     customerId : this.customerId,
                //     email : this.currentUserDetails.email,
                //     firstName : this.currentUserDetails.firstName,
                //     lastName : this.currentUserDetails.lastName,
                //     phoneNumber : this.currentUserDetails.primaryPhoneNumber
                // },
                // this.customerDetails.customerId = this.customerId;
                this.customerId = this.currentUserDetails.profileId;
                this.subscriptionObj.epcustomerId = this.currentUserDetails.profileId;
                this.customerDetails.customerId = this.currentUserDetails.profileId;
                this.customerDetails.email = this.currentUserDetails.email;
                this.customerDetails.firstName = this.currentUserDetails.firstName;
                this.customerDetails.lastName = this.currentUserDetails.lastName;
                this.customerDetails.phoneNumber = this.currentUserDetails.primaryPhoneNumber
                this.dataSharingObject.userRequesting = this.currentUserDetails.fullName
            }).catch((e) => {
                console.log(e.response)
            })
        },
        // this will invoke if current user dont register with easypay
        registerCustomer(){
            let registrationObj = {
                customerDetails : this.customerDetails,
                address: {
                    addressLine1: "",
                    addressLine2: "",
                    addressType: "",
                    city: "",
                    country: this.dataSharingObject.billingCountry,
                    postalCode: "",
                    state: ""
                },
            }
            console.log(this.customerId)
            if(this.customerId === null || this.customerId === 0 || this.customerId === undefined){
                httppayment.post('/payment/registerCustomer', registrationObj)
                .then((response) => {
                    console.log("successfully customer registered : ", response)
                    if(response.data.customerDetails) {
                        this.customerId = response.data.customerDetails.customerId;
                        this.subscriptionObj.epcustomerId = response.data.customerDetails.customerId;
                        this.customerDetails.customerId = response.data.customerDetails.customerId;
                        this.savedCustomerDetails(this.customerId)
                    }
                }).catch((e) => {
                    console.log(e.response)
                    this.displayAPIerrorModal = true;
                })
            }else{
                console.log("already registered with easy pay")
            }
            
        },
        //this will call to save customer registerd customer information into subscription table
        savedCustomerDetails(customerId){
            // var that = this;
            // let customerData = {
            //     id : null,
            //     profileId : that.currentUserProfileId,
            //     epcustomerId : customerId,
            //     startD : null,
            //     endD : null,
            //     planType : 'Customer Registration',
            //     paymentStatus : null,
            //     subscriptionD : null,
            //     transactionD : null,
            //     amount : null,
            //     status : '',
            //     transactionId : null
            // }
            // console.log(customerData)
            // httpuserprofile.post('/userprofile/SubscriptionUsers', this.subscriptionObj)
            // .then((response) => {
            //     console.log("saved customerData : ", response.data)
            //     localStorage.setItem('epCustomerId', response.data.epcustomerId)
            // }).catch((e) => {
            //     console.log(e.response)
            // })
            httpuserprofile.post('userprofile/updateUserAssignment?profileId='+this.currentUserProfileId+'&roleName=&epCustomerId='+customerId)
            .then((response) => {
                console.log("customer registration : ", response)
            }).catch((e) => {
                console.log(e.response)
            })
        },
        //this will invoke after change the country in dropdown
        setCurrencyType() {
            if(this.dataSharingObject.billingCountry === 'USA'){
                this.dataSharingObject.currencyType = 'USD'
                this.subscriptionObj.currencyType = 'USD'
                this.subscriptionObj.tax = this.usTax;
                this.monthlyPlanAmount = this.monthlyPlanAmount / this.rupeesperdollar;
                this.annualPlanAmount = this.annualPlanAmount / this.rupeesperdollar;
                this.selectedPlanAmount = this.selectedPlanAmount / this.rupeesperdollar;
            }else{
                this.dataSharingObject.currencyType = 'INR'
                this.subscriptionObj.currencyType = 'INR'
                this.subscriptionObj.tax = this.indianTax;
                this.monthlyPlanAmount = this.monthlyPlanAmount * this.rupeesperdollar;
                this.annualPlanAmount = this.annualPlanAmount * this.rupeesperdollar;
                this.selectedPlanAmount = this.selectedPlanAmount * this.rupeesperdollar
            }
            console.log(this.subscriptionObj)
        },
        /// set currency information for the payment flow from landing page
        setCurrencyTypeForDirectPricingScreen() {
            if(this.dataSharingObject.billingCountry === 'USA'){
                this.dataSharingObject.currencyType = 'USD'
                this.subscriptionObj.currencyType = 'USD'
                this.subscriptionObj.tax = this.usTax;
                this.monthlyPlanAmount = this.monthlyAmountForServices;
                this.annualPlanAmount = this.annualAmountForServices;
                if(this.selectedPlanType == 'Monthly') {
                    this.selectedPlanAmount = this.monthlyPlanAmount;
                }else{
                    this.selectedPlanAmount = this.annualPlanAmount
                }
            }else{
                this.dataSharingObject.currencyType = 'INR'
                this.subscriptionObj.currencyType = 'INR'
                this.subscriptionObj.tax = this.indianTax;
                this.monthlyPlanAmount = this.monthlyAmountForServices * this.rupeesperdollar;
                this.annualPlanAmount = this.annualAmountForServices * this.rupeesperdollar;
                if(this.selectedPlanType == 'Monthly') {
                    this.selectedPlanAmount = this.monthlyPlanAmount;
                }else{
                    this.selectedPlanAmount = this.annualPlanAmount
                }
            }
            console.log(this.subscriptionObj)
        },
        //this will incoke after successfully completed plan selection flow which is selected from landing page pricing
        navigateToHomeVideos(){
            localStorage.removeItem("selectedPlan")
            localStorage.removeItem("selectedPlanCard")
            localStorage.removeItem("billingCountry")
            router.push({
                name : 'MainHome'
            })
        },
        //this will invoke after component created to get current active plan of the user
        // getCurrentPlanDetails(){
        //     httpuserprofile.get('/userprofile/getCurrentSubscriptionPlan?profileId='+this.currentUserProfileId+'&status=y')
        //     .then((response) => {
        //         console.log("current plan : ", response)
        //         if(response.data.length > 0){
        //             this.currentPlanDetails = response.data[0];
        //             this.subscriptionObj = response.data[0]
        //             this.customerId = this.subscriptionObj.epcustomerId;
        //             this.customerDetails.customerId = this.subscriptionObj.epcustomerId;
        //             if(this.currentPlanDetails.planType === 'Monthly'){
        //                 this.monthlycardselected = true;
        //                 this.annualcardselected = false;
        //             }else if(this.currentPlanDetails.planType === 'Annually'){
        //                 this.monthlycardselected = false;
        //                 this.annualcardselected = true;
        //             }
        //         }
        //         console.log("current plan details : ", this.currentPlanDetails)
        //     }).catch((e) => {
        //         console.log(e.response)
        //     })
        // },
        //this will invoke after created the component
        getUserPlansList(){
            this.subscriptionsList = [];
            httpuserprofile.get('/userprofile/getSubscriptionListById?profileId='+this.currentUserProfileId)
            .then((response) => {
                console.log(response)
                this.subscriptionsList = response.data;
                if(this.subscriptionsList && this.subscriptionsList.length == 1){
                    if(this.subscriptionsList[0].paymentStatus == 'ACTIVE'){
                        this.HideFreeBtnBaseonPaymentStatus = true;
                    }else{
                        this.HideFreeBtnBaseonPaymentStatus = false;
                        // this.subscriptionObj = this.subscriptionsList[0];
                        // this.currentPlanDetails = this.subscriptionsList[0];
                    }
                }else{
                    this.HideFreeBtnBaseonPaymentStatus = false;
                }
            }).catch((e) => {
                console.log(e.response)
            })
        },
        //this will invoke after created the component
        getLastUpdatedPlanDetails(){
            httpuserprofile.get('/userprofile/getSubscriptionDateByprofileId?profileId='+this.currentUserProfileId)
            .then((response) => {
                console.log("last updated record in premiunm screen", response)
                let records = response.data
                if(response.data.length > 0){
                    let lastUpdatedRecord = records[0]
                    localStorage.setItem('epCustomerId', lastUpdatedRecord.epcustomerId)
                    console.log("last updated record : ", lastUpdatedRecord)
                    var dateFrom = moment(lastUpdatedRecord.startD).format("DD/MM/YYYY");
                    var dateTo = moment(lastUpdatedRecord.endD).format("DD/MM/YYYY");
                    var dateCheck = moment(new Date()).format("DD/MM/YYYY");

                    var dateFrom1 = dateFrom.split("/");
                    var dateTo1 = dateTo.split("/");
                    var dateCheck1 = dateCheck.split("/");

                    var dateFrom2 = new Date(dateFrom1[2], parseInt(dateFrom1[1])-1, dateFrom1[0]);  // -1 because months are from 0 to 11
                    var dateTo2   = new Date(dateTo1[2], parseInt(dateTo1[1])-1, dateTo1[0]);
                    var dateCheck2 = new Date(dateCheck1[2], parseInt(dateCheck1[1])-1, dateCheck1[0]);

                    // console.log("date check : ", dateCheck2 >= dateFrom2 && dateCheck2 <= dateTo2)
                    // if(dateCheck2 >= dateFrom2 && dateCheck2 <= dateTo2 && lastUpdatedRecord.status === 'Y'){
                    if(dateCheck2 >= dateFrom2 && dateCheck2 <= dateTo2 && lastUpdatedRecord.paymentStatus == 'ACTIVE'){
                        console.log("Current plan available")
                        let plan = response.data[0]
                        let amount =  plan.amount;
                        let creationD =  plan.creationD;
                        let currencyType = plan.currencyType
                        let endD = plan.endD
                        let epcustomerId = plan.epcustomerId;
                        let id = plan.id;
                        let lastUpdatedD = plan.lastUpdatedD
                        let paymentStatus = plan.paymentStatus
                        let planType = plan.planType
                        let profileId = plan.profileId
                        let startD = plan.startD
                        let status = plan.status
                        let subscriptionD = plan.subscriptionD
                        let tax = plan.tax
                        let transactionD = plan.transactionD
                        let transactionId = plan.transactionId
                        this.currentPlanDetails = {
                            amount : amount,
                            creationD : creationD,
                            currencyType : currencyType,
                            endD : endD,
                            epcustomerId : epcustomerId,
                            id : id,
                            lastUpdatedD : lastUpdatedD,
                            paymentStatus : paymentStatus,
                            planType : planType,
                            profileId : profileId,
                            startD : startD,
                            status : status,
                            subscriptionD : subscriptionD,
                            tax : tax,
                            transactionD : transactionD,
                            transactionId : transactionId
                        }
                        // this.currentPlanDetails = response.data[0];
                        this.subscriptionObj = response.data[0]
                        this.subscriptionId = this.subscriptionObj.id
                        // this.customerId = this.subscriptionObj.epcustomerId;
                        // this.customerDetails.customerId = this.subscriptionObj.epcustomerId;
                        this.customerId = this.currentUserProfileId;
                        this.customerDetails.customerId = this.currentUserProfileId;
                        if(this.currentPlanDetails.endD){
                            this.currentPlanEndDate = this.currentPlanDetails.endD
                        }
                        if(this.currentPlanDetails.planType === 'Monthly'){
                            this.monthlycardselected = true;
                            this.annualcardselected = false;
                            this.freeplancardselected = false;
                        }else if(this.currentPlanDetails.planType === 'Annually'){
                            this.monthlycardselected = false;
                            this.annualcardselected = true;
                            this.freeplancardselected = false;
                        }
                    }
                    else{
                        if(lastUpdatedRecord.planType === 'Free Trail'){
                            console.log("free trail -plan last update")
                            this.subscriptionObj = response.data[0]
                            this.subscriptionId = this.subscriptionObj.id
                            // this.customerId = this.subscriptionObj.epcustomerId;
                            // this.customerDetails.customerId = this.subscriptionObj.epcustomerId;
                            this.customerId = this.currentUserProfileId;
                            this.customerDetails.customerId = this.currentUserProfileId;
                            console.log("subscription obj in lastupdate : ", this.subscriptionObj)
                        }
                    }
                }
            }).catch((e) => {
                console.log(e.response)
            })
        },
        //this will invoke after successfully saved a plan
        getUserEntitlements() {
            htttpsignup.get("/getUserEntitlementData?ProfileId="+this.currentUserProfileId)
            .then((response) => {
                console.log("fetching user entitlements after plan updation : ", response)
                let entitlements = response.data;
                localStorage.setItem("entitlements", JSON.stringify(entitlements))
            }).catch((e) => {
                console.log(e)
                this.displayAPIerrorModal = true;
            })
        }
    },
    mounted() {
        //get the data from easy pay after successfully charged
        var eventMethod = window.addEventListener
			? "addEventListener"
			: "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === "attachEvent"
            ? "onmessage"
            : "message";
        var that = this;
        eventer(messageEvent, function (e) {
            if (e.data.APIstatus === "SUCCESS") {
                console.log("data from child : ", e.data)
                that.storedPaymentId = e.data.storedPaymentId;
                that.subscriptionObj.paymentStatus = 'ACTIVE';
                // that.subscriptionObj.transactionId = e.data.transactionId;
                // that.subscriptionObj.epcustomerId = e.data.customerId;
                // that.customerDetails.customerId = e.data.customerId;
                // that.customerId = e.data.customerId;
                that.subscriptionObj.status = 'Y';
                that.paymentToken = e.data.token;
                that.paymentSuccessful = false;
                that.paymentsection = false;
                that.choosePlanSection = true;
                if(that.dataSharingObject.reactive_upgreade_downgrade == 'reactivate') {
                    console.log("if it is reactivate plan")
                    that.subscriptionObj.status = 'Y';
                    that.schedulePaymentAfterReactivate()
                    // that.updateSubscriptionPlan('NotupdateEntitlement')
                }else if(that.dataSharingObject.reactive_upgreade_downgrade == 'upgradedowngrade'){
                    that.UpgradeDowngradeSubscription()
                }else{
                    console.log("if it is subscribe plan")
                    that.subscriptionObj.transactionId = e.data.transactionId;
                    that.paymentSuccessful = true;
                    that.paymentsection = false;
                    that.choosePlanSection = false;
                    that.updateSubscriptionPlan('updateEntitlement')
                    if(that.currentPlanDetails !== null && that.subscribeAfterPlanCancel){
                        console.log("into modify schedule")
                        that.modifySchedulePayment()
                    }else{
                        console.log("into schedule")
                        that.schedulePayment()
                    }
                    if(that.selectedPlanCard == 'true'){
                        console.log("into nav list of home videos")
                        setTimeout(function() {
                            that.navigateToHomeVideos()
                        },5000);
                    }else{
                        console.log("stay on the same page")
                    }
                }
            }
            //when click on change plan button in easypay
            if(e.data.selectPlanSection){
                that.paymentSuccessful = false;
                that.paymentsection = false;
                that.choosePlanSection = true;
                // that.getCurrentPlanDetails()
                this.getLastUpdatedPlanDetails()
            }
            // console.log(e);
        });
    },
    created(){        
        window.scrollTo(0, 0);
        this.currentUserId = sessionUtils.getUserId();
        this.currentUserProfileId = sessionUtils.getUserProfileId()
        this.subscriptionObj.profileId = this.currentUserProfileId;
        // this.remainingDaysLeft = this.$store.state.remainingDays
        // this.freeTrailAccess = this.$store.state.trailAccountFlag
        this.easypayURL = wndata.easyPayCharge;
        this.dataSharingObject.clientEmail = wndata.clientEmail;
        this.dataSharingObject.clientId = wndata.clientId;
        this.monthlyPlanAmount = wndata.monthlyAmount;
        this.annualPlanAmount = wndata.annualAmount;
        this.monthlyAmountForServices = wndata.monthlyAmount;
        this.annualAmountForServices = wndata.annualAmount;
        this.selectedPlanAmount = wndata.monthlyAmount;
        this.usTax = wndata.usTax;
        this.indianTax = wndata.indianTax;
        this.rupeesperdollar = wndata.rupeesperdollar;
        this.subscriptionObj.tax = wndata.usTax;
        // let epcustomerId = localStorage.getItem('epCustomerId')
        // if(epcustomerId !== undefined && epcustomerId !== null){
        //     this.customerId = epcustomerId;
        //     this.subscriptionObj.epcustomerId = epcustomerId;
        //     this.customerDetails.customerId = epcustomerId;
        // }
        //set initial data
        var momenttimezone = require('moment-timezone');
        var date = new Date()
        let startDate = momenttimezone.tz(date, this.zone).format()
        this.subscriptionObj.startD = startDate;
        this.subscriptionObj.subscriptionD = startDate;
        this.subscriptionObj.transactionD = startDate;
        this.getUserData()
        // this.getCurrentPlanDetails();
        this.getUserPlansList();
        this.getLastUpdatedPlanDetails()
        //get data and set all the events at a time
        this.selectedPlanCard = localStorage.getItem("selectedPlanCard")
        this.selectedPlanType = localStorage.getItem("selectedPlan");
        console.log("plancard : ", this.selectedPlanCard)
        if(this.selectedPlanCard == "true" && this.selectedPlanType !== null && this.selectedPlanType !== undefined){
            this.dataSharingObject.billingCountry = localStorage.getItem("billingCountry")
            this.setCurrencyTypeForDirectPricingScreen()
            this.changecardColour(this.selectedPlanType)
            this.loadingForLandingPricing = true;
            this.subscribesection(this.selectedPlanType)
            console.log("selected flow : ", this.selectedPlanType)
        }else{
            console.log("Normal flow : ", this.selectedPlanType)
        }
        bus.$on("openChangePlanSection", data => {
          this.movetochangePlanSection()
        });
    },
    destroyed() {
        bus.$off('openChangePlanSection')
        let obj = {
            data : false
        }
        window.removeEventListener("message", obj);
    }
}
</script>
<style scoped>
@import '../css/vue-multiselect.min.css';
html,
body,
.grid {
    height: 100%;
    width: 100%;
}
iframe{
    width: 100%;
    height: 100vh;
}
.endateheight{
    height: 15px;
}
.viewercards{
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.header {
    position: fixed;
    width: 100%;
    z-index: 10;
    background: #ffffff;
    border-bottom: 2px solid rgba(219, 219, 219,1);
}
.card-header {
    padding: 5px 10px 5px 10px;
    margin-bottom: 0;
    border: 1px solid #d9dce1;
    opacity: 0.6;
    border-radius: 8px;
}
.pageloader {
  width: 70px;
  margin-top: 15%;
  margin-left: 46%;
}
.btnsection{
    width: 100%;
}
.cardsection{
    color: #007AFF;
}
.tickmark{
    width: 25px;
    height: 25px;
    background: #007AFF;
    position: absolute;
    right: 0;
    top: 0;
    margin-right: -2px;
    border-radius: 8px;
    text-align: center;
    color: white;
    padding-bottom: 2px;
}
ul {
   list-style: none;
   line-height: 24px;
}
.card-header1 {
    border: 1px solid #d9dce1;
    opacity: 0.6;
    border-radius: 8px;
}
.paycard {
    border: none;
    border: 1px solid rgba(31, 31, 31, 0.1);
    width: 100%;
    text-align: left;
    padding: 6px;
    border-radius: 5px;
    color: rgba(31, 31, 31, 0.7);
}
.modalbtn {
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
}
.modalbtn::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  margin-top: -1px;
	background-color :  rgba(29, 27, 27, 0.3);
}
.modalbtn:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.subsec{
    width: 100%;
}
#deleteExpModal{
 margin-top: 10%;
}
#inprogressmodal{
    margin-top: 10%;
}
.modal-header{
    border-bottom: none;
}
#billingCountry{
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 5px 10px 5px 10px;
    height: 38px;
    background: none;
    color: black;
}
#billingCountry1{
    border: 1px solid rgba(0, 0, 0, 0.1);
    line-height: 38px;
    padding: 0 10px;
}
select{
    border: 1px solid rgba(31, 31, 31, 0.1);
    border-radius: 5px;
    font-family: "Proxima Nova Regular";
    color: rgba(31, 31, 31, 0.3);
    color: rgba(31, 31, 31, 0.7);
}
.carderror{
    border: 1px solid red;
}
select:focus{
    outline: none;
}
.datepicker{
    border: 1px solid rgba(31, 31, 31, 0.1);
    width: 39%;
    border-radius: 5px;
    color: rgba(31, 31, 31, 0.3);
    color: rgba(31, 31, 31, 0.7);
}
.proximanova{
    margin-top: 2px;
}
.multiselect__tags{
    background: none !important;
}
.multiselect{
    border-bottom: 1px solid rgba(31, 31, 31, 0.1) !important;
}
.multiselectInput-create {
  font-size: 18px;
  padding: 0 0 0 0;
  display: block;
  width: 100%;
  border-radius: 5px;
  border: 1px solid rgba(31, 31, 31, 0.1);
}
.paycard1{
    border: 1px solid rgba(31, 31, 31, 0.1);
    width: 100%;
    padding: 6px;
    border-radius: 5px;
    color: rgba(31, 31, 31, 0.3);
    color: rgba(31, 31, 31, 0.7);
}
.cardcvv{
    width: 39%;
}
.paycard2{
    border: 1px solid rgba(31, 31, 31, 0.1);
    width: 26%;
    padding: 6px;
    border-radius: 5px;
    color: rgba(31, 31, 31, 0.3);
    color: rgba(31, 31, 31, 0.7);
}
.paycard2:focus{
    border: 1px solid rgba(31, 31, 31, 0.1);
}
.paycard:focus{
    border: 1px solid rgba(31, 31, 31, 0.1);
}
.paycard1:focus{
    border: 1px solid rgba(31, 31, 31, 0.1);
}
.cardpayment{
    width: 100%;
}
.hotizonline {
    border-bottom: 1px solid #DDE0E6;
}
.button-cancel1 {
  border: 1px solid #1f1f1f;
  background: none;
  opacity: 0.3;
  border-radius: 4px;
  padding: 5px 10px;
  /* transition: border 8s; */
}
.starttrailbtn {
    border: none;
    padding: 6px 10px;
    font-size: 16px;
    border-radius: 4px;
}
.paymentoptions {
    background: rgba(240, 242, 245, 0.6);
    border-right: 1px solid rgba(31, 31, 31, 0.1);
    width: 30%;
}
.paymentoptions1{
    background: rgba(240, 242, 245, 0.6);
}
.borderbottom {
    border-bottom: 1px solid rgba(31, 31, 31, 0.1);
}
.cardbody{
    /* border-bottom:  1px solid rgba(31, 31, 31, 0.1); */
    border-radius: 10px;
}
.benifits{
    margin-left: -1em;
}
.benifits li{
    padding: .25em;
}
input:focus,
textarea:focus {
    outline: none; /** For Safari, etc **/
    border: transparent;
}
.card {
  border: 3px solid #F0F2F5;
  border-radius: 10px;
  background-color: #ffffff;
}
.backbtn {
    margin-top: -8px;
}
.premium {
    /* border: 1px solid #FF7676; */
    border: 2px solid #0078ff !important;
}
.font12Italic {
    font-size: 12px;
    font-family: "Proxima Nova Regulrar";
    font-style: italic;
    font-weight: bold;
    color: rgba(31, 31, 31, 0.8);
}
.followbtn {
    border: none;
    background-color: rgba(31, 31, 31,.04);
    width: 150px;
    margin: auto;
}
.planCards{
  border: 1px solid #e4e5e7;
  border-radius: 10px;
  background-color: #ffffff;
  transition: transform .3s;
}
@media screen and (max-width : 550px) {
    .pageloader {
        width: 70px;
        margin-top: 25%;
        margin-left: 42%;
    }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
@media screen and (min-width : 768px) {
    .planCards:hover {
        box-shadow: 0 10px 15px rgba(33,33,33,.2);
        border: 1px solid #007AFF;
        -ms-transform: scale(1.05); 
        -webkit-transform: scale(1.05); 
        transform: scale(1.05);
    }
}
</style>
